import Cookies from 'universal-cookie';
import { ENV_OVERRIDE_CLEAR_COOKIES } from './constants.ts';

export const clearEnvironmentOverrides = (): void => {
  const cookies = new Cookies();

  ENV_OVERRIDE_CLEAR_COOKIES.forEach(name => {
    cookies.remove(name, { path: '/' });
  });
};
